import React from 'react';
import LikertBar from './LikertBar';
import LikertBox from './LikertBox';
import { LIKERT_TYPE } from '../../dataSchema/const';

type LikertProps = {
  option?: LIKERT_TYPE,
  onSelect?: (value: number) => void;
  startText?: string;
  endText?: string;
  defaultAnswer?: { values: string[] } | null;
};

const Likert: React.FC<LikertProps> = ({ option = LIKERT_TYPE.BOX, onSelect, defaultAnswer = null, startText = "", endText = "" }) => {
  if (option === LIKERT_TYPE.BAR) {
    return <LikertBar onSelect={onSelect} defaultAnswer={defaultAnswer} startText={startText} endText={endText} />;
  }
  return <LikertBox onSelect={onSelect} defaultAnswer={defaultAnswer} startText={startText} endText={endText} />;
};

export default Likert;